import { API_URL } from 'src/app/shared/enums/api-enums';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { GetAllResponse } from '../model/restful-api.model';

@Injectable({
  providedIn: 'root'
})
export class FileSerice {

  constructor(private http: HttpClient, private utilities: UtilitiesService) { }

  upload(file, type, apiType): Observable<any> {

    const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'multipart/form-data',
        })
    };

    const formData = new FormData();
    formData.append('file', file);
    formData.append('id', '');
    formData.append('type', type);
    const url = environment.portalURL + apiType + API_URL.RESOURCE;
    return this.http.post(`${url}`, formData)
    .pipe(
        retry(0),
    );
  }

  delete(resourceId, type, apiType): Observable<GetAllResponse<any>> {
      const url = environment.portalURL + apiType + API_URL.RESOURCE + `/${resourceId}?type=${type}`;
      return this.utilities.req.httpDelete<GetAllResponse<any>>(url);
  }
}
